import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'trustAsHtml' })
export class TrustAsHtmlPipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) {}

  transform(value: string | null): SafeHtml {
    if (!value) return '';
    return this._sanitizer.bypassSecurityTrustHtml(value);
  }
}
